import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";
import { useAppointment } from "../../context/AppointmentContext";
import HeaderSkeleton from "./HeaderSkeleton";

const Header = () => {
  const [menuData, setMenuData] = useState([]);
  const [logo, setLogo] = useState("/assets/img/logo-lifeline.webp");
  const [loading, setLoading] = useState(true);
  const { openAppointment } = useAppointment();
  const [openMenuId, setOpenMenuId] = useState(null);
  const closeMobileMenu = () => {
    const navMenu = document.getElementById("nav-menu");
    const hamburger = document.getElementById("hamburger");

    navMenu?.classList.remove("active");
    hamburger?.classList.remove("open");
    setOpenMenuId(null);
  };


  useEffect(() => {
    api.get('/api/header-content')
      .then(res => {
        if (res.data.logo) {
          setLogo(`${process.env.REACT_APP_WEB_URL}${res.data.logo}`);
        }
        setMenuData(res.data.menus);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const hamburger = document.getElementById("hamburger");
    const navMenu = document.getElementById("nav-menu");

    const toggleMenu = () => {
      navMenu.classList.toggle("active");
      hamburger.classList.toggle("open");
    };

    if (hamburger && navMenu) {
      hamburger.addEventListener("click", toggleMenu);
    }

    return () => {
      if (hamburger) hamburger.removeEventListener("click", toggleMenu);
    };
  }, [menuData]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      const navMenu = document.getElementById("nav-menu");
      const hamburger = document.getElementById("hamburger");

      // click outside nav & hamburger
      if (
        navMenu &&
        hamburger &&
        !navMenu.contains(e.target) &&
        !hamburger.contains(e.target)
      ) {
        navMenu.classList.remove("active");
        hamburger.classList.remove("open");
        setOpenMenuId(null);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);



  const renderMegaMenu = (menu) => {
    const col1 = menu.children.filter(c => c.column_number === 1);
    const col2 = menu.children.filter(c => c.column_number === 2);
    const col3 = menu.children.filter(c => c.column_number === 3);

    return (
      <div className="mega-menu">
        {col1.length > 0 && (
          <div className="mega-column">
            <ul>
              {col1.map(item => (
                <li key={item.id}>
                  <Link to={item.link} onClick={closeMobileMenu}>
                    {item.icon && <img src={`${process.env.REACT_APP_WEB_URL}${item.icon}`} alt="icon" />}
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        {col2.length > 0 && (
          <div className="mega-column bg-primary-light">
            <ul>
              {col2.map(item => (
                <li key={item.id}>
                  <Link to={item.link} onClick={closeMobileMenu}>
                    {item.icon && <img src={`${process.env.REACT_APP_WEB_URL}${item.icon}`} alt="icon" />}
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        {col3.length > 0 && (
          <div className="mega-column">
            <ul>
              {col3.map(item => (
                <li key={item.id}>
                  <Link to={item.link} onClick={closeMobileMenu}>
                    {item.icon && <img src={`${process.env.REACT_APP_WEB_URL}${item.icon}`} alt="icon" />}
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  if (loading) return <HeaderSkeleton />;

  return (
    <header className="header">
      <div className="container">
        <div className="inner-header">

          <div className="logo" data-sal="fade" data-sal-duration="1000">
            <Link to="/">
              <img src={logo} alt="Lifeline Logo" />
            </Link>
          </div>

          <div className="hamburger" id="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <nav className="nav" id="nav-menu">
            <ul>
              {menuData.map((menu, index) => (
                <li
                  key={menu.id}
                  className={`main-menu ${menu.type === 'mega_menu' ? 'dropdown' : ''}`}
                  data-sal="fade"
                  data-sal-duration="300"
                  data-sal-delay={index * 50}
                >
                  {menu.type === 'mega_menu' ? (
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenMenuId(openMenuId === menu.id ? null : menu.id);
                      }}
                    >

                      {menu.title.toUpperCase()} <i className="fa-solid fa-chevron-down"></i>
                    </Link>
                  ) : (
                    <Link to={menu.link} onClick={closeMobileMenu}>
                      {menu.title.toUpperCase()}
                    </Link>

                  )}

                  {menu.type === 'mega_menu' && openMenuId === menu.id && renderMegaMenu(menu)}

                </li>
              ))}
            </ul>
          </nav>

          <div className="header-buttons">
            <button
              data-sal="fade"
              data-sal-duration="300"
              data-sal-delay="250"
              onClick={() => openAppointment("Home Page Header Button")}
              className="theme-btn pink"
            >
              APPOINTMENTS
            </button>
            <a
              href="tel:+919994288800"
              className="theme-btn red p-0"
              data-sal="fade"
              data-sal-duration="300"
              data-sal-delay="350"
            >
              <i className="fa-solid fa-truck-medical"></i>{" "}
              <span className="emergency">EMERGENCY</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;